import ScanningFeature from './ScanningFeature';
import AppLinkingFeature from './AppLinkingFeature';
import LocationsFeature from './LocationsFeature';
import BeaconsFeature from './BeaconsFeature';
import LanguagesFeature from './LanguagesFeature';
import {
  BUILDER_DEVICE_TAB,
  type BuilderDeviceTab,
} from './utils/templateBuilderTabs';

const Features = ({
  selectedTab,
  onNavigateToSharedGeofencing,
  onNavigateToAppleLocationNotifications,
  onNavigateToEnhancedTicket,
  cameFromEnhancedTicket,
  pendingExpandLocationIndex,
  onPendingExpandLocationConsumed,
  isEdit,
}: {
  selectedTab: BuilderDeviceTab;
  onNavigateToSharedGeofencing: () => void;
  onNavigateToAppleLocationNotifications: (locationId: string) => void;
  onNavigateToEnhancedTicket?: () => void;
  cameFromEnhancedTicket?: boolean;
  pendingExpandLocationIndex?: number | null;
  onPendingExpandLocationConsumed?: () => void;
  isEdit?: boolean;
}) => {
  return (
    <>
      {selectedTab === BUILDER_DEVICE_TAB.SHARED && (
        <ScanningFeature
          onNavigateToEnhancedTicket={onNavigateToEnhancedTicket}
          cameFromEnhancedTicket={cameFromEnhancedTicket}
          isEdit={isEdit}
        />
      )}
      {selectedTab !== BUILDER_DEVICE_TAB.SHARED && (
        <AppLinkingFeature selectedTab={selectedTab} />
      )}
      {selectedTab === BUILDER_DEVICE_TAB.SHARED && (
        <LocationsFeature
          selectedTab={selectedTab}
          onNavigateToSharedGeofencing={onNavigateToSharedGeofencing}
          onNavigateToAppleLocationNotifications={
            onNavigateToAppleLocationNotifications
          }
          pendingExpandLocationIndex={pendingExpandLocationIndex}
          onPendingExpandLocationConsumed={onPendingExpandLocationConsumed}
        />
      )}
      {selectedTab === BUILDER_DEVICE_TAB.SHARED && <LanguagesFeature />}
      {selectedTab === BUILDER_DEVICE_TAB.APPLE && <BeaconsFeature />}
    </>
  );
};

export default Features;
